var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLightbulb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 53 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.375 57C39.8 52.2648 42.7539 48.2273 45.6781 44.2047C46.45 43.1508 47.2219 42.0969 47.9641 41.0281C50.9031 36.7977 52.625 31.6766 52.625 26.1398C52.625 11.6969 40.9281 0 26.5 0C12.0719 0 0.375 11.6969 0.375 26.125C0.375 31.6617 2.09688 36.7977 5.03594 41.0133C5.77813 42.082 6.55 43.1359 7.32188 44.1898C10.2609 48.2125 13.2148 52.2648 14.625 56.9852H38.375V57ZM26.5 76C33.0609 76 38.375 70.6859 38.375 64.125V61.75H14.625V64.125C14.625 70.6859 19.9391 76 26.5 76ZM14.625 26.125C14.625 27.4312 13.5562 28.5 12.25 28.5C10.9438 28.5 9.875 27.4312 9.875 26.125C9.875 16.9367 17.3117 9.5 26.5 9.5C27.8062 9.5 28.875 10.5688 28.875 11.875C28.875 13.1812 27.8062 14.25 26.5 14.25C19.9391 14.25 14.625 19.5641 14.625 26.125Z",
    fill: "#858585"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightbulb);
export default __webpack_public_path__ + "static/media/lightbulb.0241648ee279c2046dbabaeef2af8d86.svg";
export { ForwardRef as ReactComponent };